module.exports = __webpack_public_path__ + "img/m-nex32-front.35747b8c.jpg";